import { useQuery } from '@tanstack/react-query';
import useLoggedIn from 'hooks/useLoggedIn';
import useProjectId from 'hooks/useProjectId';
import { userInProject } from 'queries/user/user-in-project';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Route } from 'types/types';
import routesList from '../RouteList';
import useAuthSession from 'context/AuthContext';

const ADMIN_ROUTES = ['Home', 'Events', 'Tickets', 'Profile', 'Logout', 'Admin'];
const STUDENT_ROUTES = ['Home', 'Events', 'Tickets', 'Profile', 'Logout'];
const NO_PROJECT_ROUTES = ['Logout'];
const EMPTY_ROUTES = ['Login'];

const useAccessRoutes = () => {
  const location = useLocation();
  const projectId = useProjectId();
  const loggedIn = useLoggedIn();
  const authSession = useAuthSession();
  const inProject = useQuery(userInProject({ projectId, loggedIn }));
  const [availableRoutes, setAvailableRoutes] = useState<Route[]>([]);
  const [page, setPage] = useState('');

  useEffect(() => {
    try {
      setPage(location.pathname.split('/')[2].toLocaleLowerCase());
    } catch (e) {
      setPage('');
    }
  }, [location.pathname]);

  useEffect(() => {
    const getRoutes = (): string[] => {
      if (!authSession.isActive) return EMPTY_ROUTES;
      if (!inProject.data?.isSigned) return NO_PROJECT_ROUTES;

      if (authSession.sessionData!.projectRole < 6) return ADMIN_ROUTES;
      return STUDENT_ROUTES;
    };

    setAvailableRoutes(routesList.filter((x) => getRoutes()?.includes(x.name)));
  }, [location.pathname, authSession.isActive, inProject.data?.isSigned]);

  return { availableRoutes, page };
};

export default useAccessRoutes;
